import request from './request';

// 初始化
export const common = () => {
  return request.get('/index/common');
};

// 登录
export const login = (data) => {
  return request.post(
    '/index/login',
    data
  );
};

// 发送验证码
export const sendCode = (data) => {
  return request.post(
    '/index/send_sms',
    data
  );
};

// 获取用户信息
export const userVip = () => {
  return request.get('/user/get_vip');
};

// 获取文件列表
export const diskIndex = (data) => {
  return request.post(
    'disk/index',
    data
  );
};

// 提取记录
export const diskCodeLogs = (params) => {
  return request.get(
    '/disk_code/logs',
    {params}
  );
};

// 查询口令
export const diskCodeViews = (data) => {
  return request.post(
    '/disk_code/views',
    data
  );
};

// 搜索文件
export const diskSearch = (data) => {
  return request.post(
    '/disk/search',
    data
  );
};

// 初始化OSS
export const aliyunStsToken = () => {
  return request.post(
    '/aliyun/sts_token'
  );
};

// 上传前检测文件
export const diskPreUpload = (data) => {
  return request.post(
    '/disk/pre_upload',
    data
  );
};

// 上报开始任务
export const diskStartTask = (data) => {
  return request.post(
    '/disk/start_task',
    data
  );
};

// 上传文件
export const diskUpload = (data) => {
  return request.post(
    '/disk/upload',
    data
  );
};

// 创建文件夹
export const diskAddDir = (data) => {
  return request.post(
    '/disk/add_dir',
    data
  );
};

// 获取文件夹子文件
export const dirFiles = (data) => {
  return request.post(
    '/transfer/get_dir_files',
    data
  );
};

// 获取文件详情
export const diskDetail = (data) => {
  return request.post(
    '/disk/detail',
    data
  );
};

// 删除文件
export const diskDelFile = (data) => {
  return request.post(
    '/disk/del_file',
    data
  );
};

// 修改文件名
export const diskRenameFile = (data) => {
  return request.post(
    '/disk/rename_file',
    data
  );
};

// 移动文件
export const diskMove = (data) => {
  return request.post(
    '/disk/move',
    data
  );
};

// 获取文件夹列表
export const diskDirList = (data) => {
  return request.post(
    '/disk/dir_list',
    data
  );
};

// 创建分享链接
export const diskCodeCreate = (data) => {
  return request.post(
    '/disk_code/create',
    data
  );
};

// 获取产品列表
export const products = () => {
  return request.get(
    '/user/get_products'
  );
};

// 获取权益对比
export const vipPowers = () => {
  return request.get(
    '/v2/user/vip_powers'
  );
};

// 回收站列表
export const recycleList = (data) => {
  return request.post(
    '/recycle/get_list',
    data
  );
};

// 回收站还原
export const recycleReduction = (data) => {
  return request.post(
    '/recycle/reduction',
    data
  );
};

// 回收站删除、清空
export const recycleDels = (data) => {
  return request.post(
    '/recycle/dels',
    data
  );
};

// 获取应用下载地址
export const getDownload = () => {
  return request.get('/index/get_download');
};

export const bulletFrame = () => {
  return request.get('/user/bulletFrame');
};


// WEBPACK FOOTER //
// ./src/utils/api/apis.js